import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import uuid from 'uuid';

import { ApplicationHttpClient } from '@app/core/http';
import { AuthenticationService } from '@app/core/services/authentication.service';

@Injectable({ providedIn: 'root' })
export class EmployeeService {
  constructor(
    private http: ApplicationHttpClient,
    private authService: AuthenticationService
  ) {
  }

  public getEmployeeTrees(filters = {}) {
    return this.http.get('/api/app/employee/group', {
      params: {
        ...filters
      }
    }).pipe(
      map(employees => {
        return employees.map((employee, index) => {
          const parentKey = uuid.v4();

          return {
            title: employee.groupName,
            expanded: true,
            key: parentKey,
            children: employee.employees.map(e => ({
              ...e,
              title: e.fullName,
              key: e.id.toString(),
              isLeaf: true
            }))
          };
        });
      })
    );
  }

  public upload(body: any,code:any, insuranceCompanyCode: any) {
    return this.http.post(`/api/app/employee/upload?code=${code}&insuranceCompanyCode=${insuranceCompanyCode}`, body);
  }

  public getEmployees(filters = {}) {
    return this.http.getList('/api/app/employee', {
      params: {
        ...filters
      }
    });
  }

  public getEmployeeById(id) {
    return this.http.get(`/api/app/employee/${ id }`);
  }

  public getCanCreateEmployee() {
    return this.http.get(`/api/app/employee/can-create`);
  }

  public getPressCreate() {
    return this.http.get('/api/app/employee/press-create');
  }

  public create(body, options = {}) {
    return this.http.post('/api/app/employee', body, options);
  }

  public update(id, body, options = {}) {
    return this.http.put(`/api/app/employee/${ id }`, body, options);
  }

  public delete(id) {
    return this.http.delete(`/api/app/employee/${ id }`);
  }

  public deleteMultiple(body){
    return this.http.post('/api/app/employee/multiple-delete', body);
  }

  public download(employeeId: string ) {
    return this.http.getFile(`/api/app/employee/download/${ employeeId }`, {
      headers: {
        token: this.authService.getCredentialToken()
      }
    });
  }

  public downloadImportTemplate(code: string ) {
    return this.http.getFile(`/api/app/employee/download-template?code=${ code }`, {
      headers: {
        token: this.authService.getCredentialToken()
      }
    });
  }

  public changeDepartment(body){
    return this.http.post('/api/app/employee/change-department', body);
  }

  public changeInsuranceCompanyCode(body){
    return this.http.post('/api/app/employee/change-insurance-company-code', body);
  }

  public changeStatus(body){
    return this.http.post('/api/app/employee/change-status', body);
  }

  public getTotal(){
    return this.http.get('/api/app/employee/total');
  }

  
  public exportExcel(filters = {}){
    return this.http.getFile('/api/app/employee/export-excel', {
        headers: {
            token: this.authService.getCredentialToken()
        },
        params: {
            ...filters
        }
    });
  }
}
